module.exports = __webpack_public_path__ + "static/img/far1_active.2ed40bb9.png";